import $ from 'jquery';
import {Router} from './Router.js';
import {requestJSON} from './utils.js';
import {showDesks} from './desks.js';
import {showMap} from './map.js';
import {showAlbum, showAlbums, showAlbumsTimeline, showPhoto, showPhotos, showTimeline} from './photos.js';
import {showInviteFriend, showFriends, showMe, showUserDetail, showUserEdit, showUserList} from './users.js';

let main;
let router;
let routes;

function resizeHeaderOnScroll() {
	const distanceY = window.pageYOffset || document.documentElement.scrollTop,
	shrinkOn = 100,
	headerElem = document.getElementById("js-header");

	if (headerElem) {
		if (distanceY > shrinkOn) {
			headerElem.classList.add("rolled");
		} else {
			headerElem.classList.remove("rolled");
		}
	}
}

window.addEventListener("scroll", resizeHeaderOnScroll);

function setBreadcrumb(breadcrumb)
{
	let breadcrumbElement = document.querySelector(".js-breadcrumb > ol");

	while (breadcrumbElement.children.length > 1) {
		breadcrumbElement.removeChild(breadcrumbElement.lastChild);
	}

	for (let i = 0; i < breadcrumb.length; i++) {
		let b = document.createElement("li");
		b.classList.add("breadcrumb-item");

		if ("url" in breadcrumb[i]) {
			let a = document.createElement("a");
			a.textContent = breadcrumb[i].title;
			a.href = breadcrumb[i].url;
			a.addEventListener("click", function (e) {
				e.preventDefault();
				router.navigate(breadcrumb[i].url);
			});
			b.appendChild(a);
		} else {
			b.textContent = breadcrumb[i].title;
			b.classList.add("active");
			b.setAttribute("aria-current", "page");
		}

		breadcrumbElement.appendChild(b);
	}
}

function setTitle(title)
{
	document.title = (title != "" ? title + " - " : "") + "Hub";
}

function navigateToHref(event)
{
	event.preventDefault();
	router.navigate(this.getAttribute("href"));
}

function switchTo(section)
{
	let activeElem = document.querySelector("#js-header > ul > li.active");
	if (section !== activeElem) {
		if (activeElem) {
			activeElem.classList.remove("active");
		}
		section.classList.add("active");
	}
}

function createNav(items, active)
{
	let nav = document.createElement("nav");
	nav.classList.add("menu", "submenu");
	let ul = document.createElement("ul");
	nav.appendChild(ul);

	for (let i in items) {
		let item = items[i];
		let link = document.createElement("a");
		link.href = router.generateUrl(item.routeName);
		link.textContent = item.name;
		link.addEventListener("click", navigateToHref);

		let li = document.createElement("li");

		if (i == active) {
			li.classList.add("active");
		}

		li.appendChild(link);
		ul.appendChild(li);

	}

	return nav;
}

function insertMessage(messagesElem, from, sentOn, content) {
	// toLocaleDateString options
	let options = {
		weekday: 'long', month: 'long', day: 'numeric',
		hour: 'numeric', minute: 'numeric'
	};

	let messageElem = document.createElement("div");

	let fromElem = document.createElement("strong");
	fromElem.textContent = from;
	messageElem.appendChild(fromElem);

	let sentOnElem = document.createElement("time");
	sentOnElem.dateTime = sentOn;
	sentOnElem.textContent = new Date(sentOn).toLocaleDateString(navigator.language, options);
	messageElem.appendChild(sentOnElem);

	let contentElem = document.createElement("p");
	contentElem.textContent = content;
	messageElem.appendChild(contentElem);

	messagesElem.appendChild(messageElem);
}

function onDocumentReady() {
	main = document.querySelector("main");

	router = new Router(main.dataset.basePath);
	routes = JSON.parse(main.dataset.routes);

	router.add("/", showRecent, "home");

	router.add("/albums", showAlbums, "album.list");

	router.add('/albums/{after:[-0-9]+}', showAlbumsTimeline, "album.after");

	router.add('/albums/{selector:[a-z0-9]+}', showAlbum, "album.detail");

	router.add('/albums/{album_selector:[a-z0-9]+}/{selector:[a-z0-9]+}', showPhoto, "album.photo.detail");

	router.add("/conversations", function () {
		setTitle("Konverzace");
		setBreadcrumb([{title: "Konverzace"}]);
		switchTo(document.querySelector(".js-nav-conversations"));
		showConversations();
	}, "conversation.list");

	router.add("/desks", showDesks, "desk.list");

	router.add("/events", function () {
		setTitle("Události");
		setBreadcrumb([{title: "Události"}]);
		switchTo(document.querySelector(".js-nav-events"));
		main.textContent = '';
	}, "event.list");

	router.add("/friends", showFriends, "friend.list");

	router.add("/friends/invite", showInviteFriend, "friend.invite");

	router.add("/map", function () {
		setTitle("Mapa");
		setBreadcrumb([{title: "Mapa"}]);
		switchTo(document.querySelector(".js-nav-map"));
		showMap();
	}, "map");

	router.add("/me", showMe, "me");

	router.add("/photos", showPhotos, "photo.list");

	router.add('/photos/{after:[-0-9]+}', showTimeline, "photo.after");

	router.add('/photos/{selector:[a-z0-9]+}', showPhoto, "photo.detail");

	router.add('/users/{id}', showUserDetail, "user.detail");

	router.add('/users/{id}/edit', showUserEdit, "user.edit");

	router.add("/users", showUserList, "user.list");

	document.querySelector(".js-breadcrumb > ol > li > a").addEventListener("click", navigateToHref);

	let header = document.getElementById("js-header");
	header.querySelector("ul").insertAdjacentHTML("afterbegin", `
			<li class="js-nav js-nav-home"><a href="${router.generateUrl("home")}"><span class="icon"><i class="fas fa-home" aria-hidden="true"></i></span><span>Přehled</span></a></li>
			<li class="js-nav js-nav-friends"><a href="${router.generateUrl("friend.list")}"><span class="icon"><i class="fas fa-users" aria-hidden="true"></i></span><span>Přátelé</span></a></li>
			<li class="js-nav js-nav-photos"><a href="${router.generateUrl("photo.list")}"><span class="icon"><i class="fas fa-images" aria-hidden="true"></i></span><span>Fotky</span></a></li>
			<li class="js-nav js-nav-map"><a href="${router.generateUrl("map")}"><span class="icon"><i class="fas fa-map" aria-hidden="true"></i></span><span>Mapa</span></a></li>
`);

	let origHeader = `
			<li class="js-nav js-nav-home"><a href="${router.generateUrl("home")}"><span class="icon"><i class="fas fa-home" aria-hidden="true"></i></span><span>Přehled</span></a></li>
			<li class="js-nav js-nav-conversations"><a href="${router.generateUrl("conversation.list")}"><span class="icon"><i class="fas fa-comments" aria-hidden="true"></i></span><span>Konverzace</span></a></li>
			<li class="js-nav js-nav-events"><a href="${router.generateUrl("event.list")}"><span class="icon"><i class="fas fa-calendar" aria-hidden="true"></i></span><span>Události</span></a></li>
			<li class="js-nav js-nav-friends"><a href="${router.generateUrl("friend.list")}"><span class="icon"><i class="fas fa-users" aria-hidden="true"></i><span class="unread">4</span></span><span>Přátelé</span></a></li>
			<li class="js-nav js-nav-photos"><a href="${router.generateUrl("photo.list")}"><span class="icon"><i class="fas fa-images" aria-hidden="true"></i></span><span>Fotky</span></a></li>
			<li class="js-nav js-nav-map"><a href="${router.generateUrl("map")}"><span class="icon"><i class="fas fa-map" aria-hidden="true"></i></span><span>Mapa</span></a></li>
			<li class="js-nav js-nav-desks"><a href="${router.generateUrl("desk.list")}"><span class="icon"><i class="fas fa-object-group" aria-hidden="true"></i></span><span>Stůl</span></a></li>
`;

	header.querySelectorAll(".js-nav > a").forEach(function (link) {
		link.addEventListener("click", navigateToHref);
	});

	router.dispatch();

	pullData();

	// Open a conversation
	main.addEventListener("click", function (e) {
		if (e.target.classList.contains("js-conversation")) {
			let id = e.target.dataset.id;
			let data = e.target.dataset.conversation;
			showConversation(id, JSON.parse(data));
		}
	});
}

function onMessageSubmit(event) {
	event.preventDefault();

	let form = this;
	let conversationElem = $(form).parents(".js-conversation-open");
	let messagesElem = conversationElem.querySelector(".js-messages");
	let id = conversationElem.dataset.id;

	var jqxhr = $.post("/api/conversations/" + id + "/messages/new", form.serialize());
	jqxhr.done(function (messageData) {
		let textarea = form.querySelector("textarea");
		insertMessage(messagesElem, "já", new Date().toISOString(), textarea.value);
		textarea.value = "";
	});
}

function pullData() {
	var jqxhr = $.post(routes["pull"], {conversations: [1]});
	jqxhr.done(function (data) {
		var openConversations = $(".js-conversation-open");

		openConversations.each(function (index, element) {
			let conversationElem = element;
			let id = conversationElem.dataset.id;
			let participants = JSON.parse(conversationElem.dataset.conversation).participants;
			let messagesElem = conversationElem.querySelector(".js-messages");

			if ("conversations" in data) {
				if (id in data.conversations) {
					if ("messages" in data.conversations[id]) {
						var messages = data.conversations[id].messages;
						for (var i in messages) {
							var m = messages[i];
							insertMessage(messagesElem, participants[m.from_user_id].display_name, m.sent_on, m.content);
						}
					}
				}
			}
		});
		//setTimeout(pullData, 10000);
	});
	jqxhr.fail(function (data) {
		// TODO
	});
}

function showConversation(id, data) {
	let conversationElem = document.createElement("article");
	conversationElem.dataset.id = id;
	conversationElem.dataset.conversation = JSON.stringify(data);
	conversationElem.classList.add("tile", "list", "conversation-open", "js-conversation-open");

	let messagesElem = document.createElement("div");
	messagesElem.classList.add("js-messages");
	conversationElem.appendChild(messagesElem);

	var form = $("<form>");
	form.submit(onMessageSubmit);
	conversationElem.appendChild(form[0]);

	var newMessage = $("<textarea>");
	newMessage.attr("name", "content");
	newMessage.appendTo(form);

	var submit = $("<button>");
	submit.attr("type", "submit");
	submit.text("Odeslat");
	submit.appendTo(form);

	// Load conversation
	var jqxhr = $.post("/api/conversations/" + id);
	jqxhr.done(function (conversation) {
		main.textContent = '';

		for (let id in conversation.messages) {
			let m = conversation.messages[id];
			let from = data.participants[m.from_user_id].display_name;

			insertMessage(messagesElem, from, m.sent_on, m.content);
		}

		main.appendChild(conversationElem);
	});
	jqxhr.fail(function (data) {
		// TODO
	});
}

function showConversations() {
	main.textContent = '';

	// Load conversations
	var jqxhr = $.post(routes["conversation.list"]);
	jqxhr.done(function (conversations) {
		let conversationsElem = document.createElement("section");
		conversationsElem.classList.add("tile", "list");

		for (let id in conversations) {
			let c = conversations[id];
			let conversation = document.createElement("div");
			conversation.classList.add("conversation", "js-conversation");
			conversation.dataset.id = id;
			conversation.dataset.conversation = JSON.stringify(c);

			var names = [];

			for (let userId in c.participants) {
				if (c.participants[userId].relationship != "me") {
					names.push(c.participants[userId].display_name);
				}
			}

			var name = c.name;
			if (name.length == 0) {
				name = names.join(", ");
			}
			conversation.textContent = name;

			conversationsElem.appendChild(conversation);
		}

		main.appendChild(conversationsElem);
	});
	jqxhr.fail(function (data) {
		// TODO
	});
}

function showRecent() {
	// TODO: show "recent" human readable
	setTitle("");
	setBreadcrumb([]);
	switchTo(document.querySelector(".js-nav-home"));

	requestJSON('POST', routes["recent"], null, function (xhr) {
		let intlOptions = {
			weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
		};
		let intl = new Intl.DateTimeFormat(navigator.language, intlOptions);

		let recentEvents = xhr.response;

		main.textContent = '';

		let elem = document.createElement("section");
		elem.classList.add("tile");

		elem.insertAdjacentHTML("afterbegin", `
<header class="tile-header">
	<h2>Nedávná sdílení</h2>
</header>`);

		let body = document.createElement("div");
		//body.classList.add("tile-body");
		elem.appendChild(body);

		let recentElem = document.createElement("div");
		recentElem.classList.add("list-group");
		body.appendChild(recentElem);

		if (recentEvents.length == 0) {
			let nothingMsgElem = document.createElement("div");
			nothingMsgElem.classList.add("tile-body");
			nothingMsgElem.textContent = "Žádná nedávná sdílení";
			recentElem.appendChild(nothingMsgElem);
		}

		for (let id in recentEvents) {
			let r = recentEvents[id];
			let recent = document.createElement("li");
			recent.classList.add("list-group-item");
			let recentLink = document.createElement("a");
			recentLink.href = router.generateUrl("album.detail", {selector: r.album_selector});
			recentLink.textContent = r.album_name;
			recentLink.addEventListener("click", navigateToHref);
			recent.appendChild(recentLink);
			recent.insertAdjacentHTML("beforeend", `
<span class="text-black-50" style="margin-left: 1em">sdílí ${r.shared_by_display_name},
<time datetime="${r.since}">${intl.format(new Date(r.since))}</time></span>`);

			recentElem.appendChild(recent);
		}

		/*
		elem.insertAdjacentHTML("beforeend", `<select multiple class="js-test-select">
	<option value="A">A</option>
	<option value="B">B</option>
	<option value="C">C</option>
	<option value="D">D</option>
</select>`);

		const choices = new Choices(elem.querySelector(".js-test-select"));
		*/

		main.appendChild(elem);
	});
}

document.addEventListener('DOMContentLoaded', function () {
	if (document.getElementById("js-header")) {
		onDocumentReady();
	}
});

export {
	createNav,
	main,
	navigateToHref,
	router,
	routes,
	setBreadcrumb,
	setTitle,
	switchTo
};
